'use client';

import { css } from '@repo/pandacss/styled-system/css';
import { button } from '@repo/pandacss/styled-system/recipes';
import { BrandIcon } from '@repo/ui-v2/BrandIcon';
import { Dropdown } from '@repo/ui-v2/Dropdown';
import { useState } from 'react';
import { labelToDomIdSegment } from '../../utils/sanitizeDomIdSegment';
import { SMBInfoGatheringCtaProps } from './types';

export function SMBInfoGatheringCta({ props }: SMBInfoGatheringCtaProps) {
  const { headline, answers = [], ctaText = 'learn more', icon, subText } = props;
  const [selectedAnswer, setSelectedAnswer] = useState(answers?.[0]);

  const dropdownOptions = answers.map(a => ({ label: a.answer, value: a.answer }));

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: { base: 'column', md: 'row' },
        columnGap: '2',
        rowGap: '2',
        boxShadow:
          '[0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)]',
        marginBlockStart: '8',
        marginBlockEnd: '8',
      })}
    >
      <div
        className={css({
          display: 'flex',
          flexGrow: '1',
          flexShrink: '1',
          flexBasis: '[0%]',
          paddingTop: { base: '6', md: '7' },
          paddingRight: { base: '6', md: '7' },
          paddingBottom: { base: '6', md: '7' },
          paddingLeft: { base: '6', md: '7' },
          backgroundColor: 'green.lightest',
          flexDirection: { base: 'column', md: 'row' },
          justifyContent: 'space-between',
          columnGap: { base: '2', md: '0' },
          rowGap: { base: '2', md: '0' },
        })}
      >
        {icon ? (
          <div
            className={css({
              display: 'flex',
              flexGrow: '1',
              flexShrink: '1',
              flexBasis: '[0%]',
              alignSelf: { base: 'center', md: 'start' },
              marginRight: { base: '0', md: '2' },
            })}
          >
            <div
              className={css({
                backgroundColor: 'green.dark',
                borderTopLeftRadius: 'half',
                borderTopRightRadius: 'half',
                borderBottomRightRadius: 'half',
                borderBottomLeftRadius: 'half',
                height: '[60px]',
                width: '[60px]',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              })}
            >
              <BrandIcon
                name={icon}
                size={40}
                className={css({
                  filter: '[brightness(0) invert(1)]',
                })}
              />
            </div>
          </div>
        ) : null}
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            flexGrow: '[3]',
            flexShrink: '1',
            flexBasis: '[0%]',
          })}
        >
          <p className={css({ textStyle: 'textBold' })}>{headline}</p>
          {subText && <p className={css({ textStyle: 'text' })}>{subText}</p>}
        </div>
      </div>
      <div
        className={css({
          display: 'flex',
          flexGrow: '1',
          flexShrink: '1',
          flexBasis: '[0%]',
          flexDirection: 'column',
          paddingTop: { base: '6', md: '7' },
          paddingRight: { base: '6', md: '7' },
          paddingBottom: { base: '6', md: '7' },
          paddingLeft: { base: '6', md: '7' },
          marginBottom: '1',
        })}
      >
        {answers?.length > 0 && (
          <Dropdown
            aria-label="Select an answer"
            id={labelToDomIdSegment(`${headline}-answer`, 'info-gathering-answer')}
            name={labelToDomIdSegment(`${headline}-answer`, 'info-gathering-answer')}
            value={selectedAnswer?.answer || ''}
            options={dropdownOptions}
            onChange={value => {
              const currentAnswer = answers.find(a => a.answer === value);
              if (currentAnswer) {
                setSelectedAnswer(currentAnswer);
              }
            }}
          />
        )}
        <div
          className={css({
            marginTop: '2',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
          })}
        >
          <a
            href={selectedAnswer?.destination || 'https://www.nerdwallet.com'}
            target="_blank"
            rel="noopener noreferrer"
            className={button({ variant: 'primary' })}
          >
            {ctaText}
          </a>
          <span
            className={css({
              textStyle: 'textSmall',
              color: 'neutral.darker',
              marginTop: '1',
            })}
          >
            {"on NerdWallet's secure site"}
          </span>
        </div>
      </div>
    </div>
  );
}
